import jwtDecode from 'jwt-decode'
import axios from '../../helpers/axios'
import ExpireDate from '../../storage/expireDate'
import Token from '../../storage/token'
import User from '../../storage/user'

export default {

  state:{
    user : User.get() !== null ? User.get() : null,
    token : Token.get() !== null ? Token.get() : null,
    expireDate : ExpireDate.get() !== null ? ExpireDate.get() : null,

    loginProcess: null,
    loginSuccess : null,
    loginError : null,

    registerProcess: null,
    registerSuccess: null,
    registerError: null,

    confirmMailProcess : null,
    confirmMailError:null,
    confirmMailSuccess:null


  },

  getters:{
    user : state => state.user,
    token : state => state.token,
    expireDate : state => state.expireDate,

    loginProcess: state => state.loginProcess,
    loginSuccess: state => state.loginSuccess,
    loginError: state => state.loginError,

    registerProcess : state => state.registerProcess,
    registerSuccess : state => state.registerSuccess,
    registerError : state => state.registerError,

    confirmMailProcess : state => state.confirmMailProcess,
    confirmMailSuccess : state => state.confirmMailSuccess,
    confirmMailError : state => state.confirmMailError


  },

  mutations:{
    SET_USER (state, payload) {
      state.user = payload
    },
    SET_TOKEN (state, payload) {
      state.token = payload
    },
    SET_EXPIRE_DATE (state, payload) {
      state.expireDate = payload
    },

    // Login State

    LOGIN_PROCESS (state, payload) {
      state.loginProcess = payload
    },
    LOGIN_SUCCESS (state, payload) {
      state.loginSuccess = payload
    },
    LOGIN_ERROR (state, payload) {
      state.loginError = payload
    },
  
    CLEAR_LOGIN (state) {
      state.loginError = null
      state.loginProcess = null
      state.loginSuccess = null
    },

    // register state
  
    REGISTER_PROCESS (state, payload) {
      state.registerProcess = payload
    },
    REGISTER_SUCCESS (state, payload) {
      state.registerSuccess = payload
    },
    REGISTER_ERROR (state, payload) {
      state.registerError = payload
    },
    CLEAR_REGISTER (state) {
      state.registerError = null
      state.registerProcess = null
      state.registerSuccess = null
    },
  
    // ResetPassword state
  
    CONFIRM_MAIL_PROCESS (state, payload) {
      state.confirmMailProcess = payload
    },
    CONFIRM_MAIL_SUCCESS (state, payload) {
      state.confirmMailSuccess = payload
    },
    CONFIRM_MAIL_ERROR (state, payload) {
      state.confirmMailError = payload
    },
    CONFIRM_MAIL_CLEAR (state) {
      state.confirmMailError = null
      state.confirmMailSuccess = null
      state.confirmMailProcess = null
    }

  },

  actions:{
    loginUser ({commit, dispatch}, payload) {
      commit('CLEAR_LOGIN')
      commit('LOGIN_PROCESS', true)
      axios.post('/oauth/servers/login', JSON.stringify(payload)).then((result) => {
        commit('LOGIN_PROCESS', false)
      
        commit('SET_TOKEN', result.data.access_token)
        Token.set(result.data.access_token)
        ExpireDate.set(jwtDecode(result.data.access_token).exp * 1000)
        dispatch('getUser')
      })
        .catch(error => {
       
          commit('LOGIN_PROCESS', false)
          if (error.response) {
            commit('LOGIN_ERROR', error.response)
          } else if (error.request) {
            commit('LOGIN_ERROR', error.request)
          } else {
            commit('LOGIN_ERROR', error.message)
          }
          setTimeout(() => {
            commit('CLEAR_LOGIN')
          }, 3000)
        })
    },
    getUser ({commit, state}) {
      axios.get('/oauth/user/get-user-info', {
        headers:{
          Authorization: `Bearer ${state.token}`
        }
      }   
      ).then(result => {
        const  data  = result.data
        User.set(data)
        commit('SET_USER', data)
        commit('LOGIN_SUCCESS', true)
        commit('BECOME_OWNER_SUCCESS', true)
      }).catch(error => {
       
        commit('LOGIN_PROCESS', false)
        if (error.response) {
          commit('LOGIN_ERROR', error.response)
        } else if (error.request) {
          commit('LOGIN_ERROR', error.request)
        } else {
          commit('LOGIN_ERROR', error.message)
        }
        setTimeout(() => {
          commit('CLEAR_LOGIN')
        }, 3000)
      })
    },
    loginWithGoogle ({commit, dispatch}, payload) {
      commit('SET_TOKEN', payload.access_token)
     
      Token.set(payload.access_token)
      ExpireDate.set(jwtDecode(payload.access_token).exp * 1000)
      dispatch('getUser')
    },


    registerUser ({commit}, payload) {
      commit('CLEAR_REGISTER')
      commit('REGISTER_PROCESS', true)
      const data = JSON.stringify({
        user:{
          username : payload.user.username,
          password: payload.user.password,
          email:payload.user.email,
          phone:payload.user.phone
        },
        personalData:{
          firstname : payload.personalData.firstName,
          lastName: payload.personalData.lastName,
          sex: payload.personalData.sex,
          adress: payload.personalData.adress,
          birthDate: payload.personalData.birthDate,
          country: payload.personalData.country
        },
        callbackUrl: `${window.location.protocol}//${window.location.hostname}/confirm-mail/`
      })
    
      axios.post('/oauth/servers/user/create', data).then(res => {
        commit('REGISTER_PROCESS', false)
        commit('REGISTER_SUCCESS', res.data)
      })
        .catch(error => {
          commit('REGISTER_PROCESS', false)
          if (error.response) {
            commit('REGISTER_ERROR', error.response.data)
          } else if (error.request) {
            commit('REGISTER_ERROR', error.request)
          } else {
            commit('REGISTER_ERROR', error.message)
          }
          setTimeout(() => {
            commit('CLEAR_REGISTER')
          }, 3000)
        })
    }
  }
}